import { useEffect, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { api } from "./lib/api";
import { useHash, parseHash, match, navigate } from "./lib/router";
import PasswordGate from "./components/PasswordGate";
import SidebarNav from "./components/SidebarNav";
import ProjectsPage from "./pages/ProjectsPage";
import NewProjectWizard from "./pages/NewProjectWizard";
import ProjectShell from "./pages/ProjectShell";
import SettingsPage from "./pages/SettingsPage";
import Placeholder from "./pages/Placeholder";

export default function App() {
  const [unlocked, setUnlocked] = useState(false);
  const auth = useQuery({ queryKey: ["auth"], queryFn: api.authStatus });

  useEffect(() => {
    if (auth.data?.authenticated) setUnlocked(true);
  }, [auth.data]);

  if (auth.isLoading) {
    return (
      <div className="center-screen">
        <span className="spinner" style={{ width: 28, height: 28 }} />
      </div>
    );
  }

  if (!unlocked && !auth.data?.authenticated) {
    return <PasswordGate onUnlock={() => setUnlocked(true)} />;
  }

  return <Shell />;
}

function Shell() {
  const hash = useHash();
  const route = parseHash(hash);

  useEffect(() => {
    if (route.path === "/") navigate("/projects");
  }, [route.path]);

  return (
    <div className="app">
      <SidebarNav activePrefix={"/" + (route.parts[0] ?? "")} />
      <div className="main">
        <Router route={route} />
      </div>
    </div>
  );
}

function Router({ route }: { route: ReturnType<typeof parseHash> }) {
  if (match("/projects/new", route)) return <NewProjectWizard />;
  const proj = match("/projects/:id/:tab", route) || match("/projects/:id", route);
  if (proj && route.parts[0] === "projects" && route.parts[1] !== "new") {
    return <ProjectShell projectId={proj.id} tab={(proj as { tab?: string }).tab ?? "board"} />;
  }
  if (match("/projects", route) || route.path === "/") return <ProjectsPage />;
  if (match("/settings", route)) return <SettingsPage />;
  if (match("/brand-kits", route)) return <Placeholder title="Бренд-кіти" note="Незабаром: збережені бренд-кіти Kidden (лого, палітра, шрифти) для авто-підстановки." />;
  if (match("/exports", route)) return <Placeholder title="Експорти" note="Тут зберігатимуться зібрані пакети для дизайнера (ZIP)." />;
  if (match("/archived", route)) return <Placeholder title="Архів" note="Архівовані проєкти." />;
  return <Placeholder title="Не знайдено" note="Такої сторінки немає." />;
}
